const STORAGE_KEY = 'gisliberty_demo_color_mode';

export function readStoredColorMode() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark' || stored === 'system') return stored;
  } catch { /* ignore */ }
  return 'system';
}

export function resolveColorMode(mode) {
  if (mode === 'light' || mode === 'dark') return mode;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function persistColorMode(mode) {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch { /* ignore */ }
  document.documentElement.dataset.colorMode = resolveColorMode(mode);
}

export function applyColorMode(mode) {
  document.documentElement.dataset.colorMode = resolveColorMode(mode);
}
